exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lang-en .confirm-item[data-v-60e5efe9] .el-form-item__label{line-height:1.2\n}\n.title[data-v-60e5efe9]{font-size:12px;text-align:center\n}\n.modal[data-v-60e5efe9]{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.5);z-index:8887;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center\n}\n.main-form[data-v-60e5efe9]{width:425px;background:#fff;height:300px;border-radius:6px;padding:50px\n}\n.form[data-v-60e5efe9]{margin-top:30px;text-align:center\n}", ""]);

// exports
